"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.camelToDash = void 0;
/**
 * Convert camelCase strings into kebab-case
 * e.g. fooBar becomes foo-bar
 */
var camelToDash = function (str) {
    return str
        .replace(/[A-Z]/g, function (m) { return '-' + m; })
        .toLowerCase()
        .replace(/^-/, '');
};
exports.camelToDash = camelToDash;
